// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import barChart02Icon from "@/assets/icons/bar-chart-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type BarChart02IconProps = Omit<IconProps, "name">;

export function BarChart02Icon(props: BarChart02IconProps): React.ReactNode {
  return <Icon name={barChart02Icon} {...props} />;
}
